var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "monitor-table-page",
      class: {
        "monitor-table-page--open-chart": _vm.is_show_chart_dialog,
        "monitor-table-page--open-map": _vm.is_monitor_open_emap
      },
      attrs: { id: "monitor-table-page" }
    },
    [
      _c("div", { staticClass: "monitor-table-page__title" }, [
        _c("h2", { style: { "font-size": _vm.title_size + "px" } }, [
          _vm._v("\n            " + _vm._s(_vm.table_title) + "\n        ")
        ]),
        _vm._v(" "),
        _vm.is_current_monitor
          ? _c(
              "div",
              { staticClass: "description" },
              [_vm._t("description")],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.is_current_monitor
          ? _c(
              "div",
              { staticClass: "description" },
              [_vm._t("description_history")],
              2
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.history_monitor_list.includes(_vm.default_value) &&
      !_vm.in_overview_page
        ? _c(
            "div",
            {
              staticStyle: { margin: "5px 0" },
              attrs: { id: "monitor-switch" }
            },
            [
              _c(
                "v-btn",
                {
                  class: _vm.is_current_monitor
                    ? "btn-clicked"
                    : "btn-unclicked",
                  attrs: {
                    id: "current-monitor-btn",
                    ripple: false,
                    color: _vm.is_current_monitor ? "#8dba6f" : "#b7cda8"
                  },
                  on: {
                    click: function($event) {
                      _vm.is_current_monitor = true
                    }
                  }
                },
                [_vm._v(" \n            即時監測 \n        ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  class: _vm.is_current_monitor
                    ? "btn-unclicked"
                    : "btn-clicked",
                  attrs: {
                    id: "history-monitor-btn",
                    ripple: false,
                    color: _vm.is_current_monitor ? "#b7cda8" : "#8dba6f"
                  },
                  on: {
                    click: function($event) {
                      _vm.is_current_monitor = false
                    }
                  }
                },
                [_vm._v(" \n            歷史燈號 \n        ")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { display: "inline-block", "margin-left": "15px" } },
        [
          !_vm.history_monitor_list.includes(_vm.default_value) ||
          _vm.is_current_monitor
            ? _vm._t("datetime")
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "signs-wrapper" } },
        [_vm.is_current_monitor ? _vm._t("signs") : _vm._e()],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "control-table-tool",
          style: _vm.is_current_monitor ? "" : "margin-bottom: -20px",
          attrs: { id: "control-table-tool" }
        },
        [
          _c(
            "div",
            { staticClass: "start" },
            [
              !_vm.is_current_monitor ? _vm._t("datetime_interval") : _vm._e(),
              _vm._v(" "),
              _vm._t("filter_condition_options", function() {
                return [_c("span")]
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "end" },
            [
              _vm._t("description_th"),
              _vm._v(" "),
              _c("SearchField", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.show_search_text,
                    expression: "show_search_text"
                  }
                ],
                attrs: { search: _vm.search },
                on: {
                  "update:search": function($event) {
                    _vm.search = $event
                  }
                }
              })
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "monitor-table-page__table-wrapper" },
        [
          _vm.is_current_monitor
            ? _vm._t("data_table", null, { search: _vm.search })
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "history-data-table" },
        [
          !_vm.is_current_monitor
            ? _vm._t("history_data_table", null, {
                search: _vm.search,
                search_column: _vm.search_column
              })
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "hint-dialog" },
        [!_vm.is_current_monitor ? _vm._t("hint_dialog") : _vm._e()],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }